import { BootstrapColors, FontAwesomeIcons } from "../../core/Types";
import { useEnvironment } from "../../core/Global";
import Icon from "./Icon";


type AvatarProps = {
    avatarUrl?: string
    fullName?: string
    className?: string
    width?: number
    textSize?: number
    background?: BootstrapColors
    icon?: FontAwesomeIcons
    type?: "circle" | "square"
    onClick?: () => void
}


function Avatar(props: AvatarProps) {

    const env = useEnvironment()

    return (
        <div className={`symbol ${props.type == "square" ? "" : "symbol-circle"} ${props.onClick ? "cursor-pointer" : ""} overflow-hidden ${props.className}`}
            onClick={e => {
                e.preventDefault()
                props.onClick?.()
            }}>
            <div className={`symbol-label bg-${props.background ?? "primary"}`} style={{
                width: props.width ?? 50,
                height: props.width ?? 50
            }}>
                {
                    (!window.isNullOrEmpty(props.fullName) || !window.isNullOrEmpty(props.icon)) && (window.isNullOrEmpty(props.avatarUrl) || props.avatarUrl == "/assets/media/avatars/blank.png") ?
                        <span className={`text-white ${(props.textSize ? "" : (props.width ?? 50) < 20 ? "fs-9" : (props.width ?? 50) < 24 ? "fs-8" : "fs-6")}`} style={{
                            paddingTop: 2,
                            textTransform: "capitalize",
                            fontSize: props.textSize
                        }}>
                            {
                                props.icon ? <Icon icon={props.icon} type="solid" /> : <>{props.fullName?.substring(0, 1)}</>
                            }
                        </span>
                        :
                        <img src={props.avatarUrl ? (props.avatarUrl.startsWith("http") ? props.avatarUrl : (env.hubUrl + props.avatarUrl)) : "/assets/media/avatars/blank.png"} className="w-100" />
                }

            </div>
        </div>
    )
}

export default Avatar;

